<div class="card">
    <div class="card-header card-chart card-header-primary p-2">
        <div class="row align-items-center">
            <div class="col-sm-10 col-md-10">
                <h2 class="card-title"><b>Historial de avances</b></h2>
            </div>
            <div class="col-sm-2 col-md-2">
                <button mat-icon-button (click)="onNoClick()">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>

        </div>
      </div>
    <div class="card-body">
            <div class="container container-comentarios" >
                    <div *ngFor="let item of data.comentariosAvances">
                        <div class="mb-3 mt-2">
                            <div class="row">
                                <div class="col-3 text-muted">
                                    <small>
                                        <i class="material-icons align-text-top fs-6">calendar_month</i>
                                    </small> 
                                    Fecha:
                                </div>
                                <div class="col"> {{item.fecha}} </div>
                            </div>
                            <div class="row">
                                <div class="col-3 text-muted">
                                    <i class="material-icons align-text-top fs-6">person</i>Autor:</div>
                                <div class="col"> {{item.nombreUsuario}} </div>
                            </div>
                            <div class="row"> 
                                <div class="col-3 text-muted"> 
                                    <i class="material-icons align-text-top fs-6">description</i>Comentario:
                                </div>
                                <div class="col"> {{item.descripcion}}</div></div>
                            <div class="row">
                                <div class="col-3 text-muted">
                                    <i class="material-icons align-text-top fs-6">show_chart</i>Avance:
                                </div>
                                <div class="col"> <span class="span-avance">{{item.porcentajeRegistrado}} %</span></div>
                            </div>
                           
                           
                        </div>
                    </div>
            </div>
    </div>
</div>